import {
	Accordion,
	AccordionBody,
	AccordionHeader,
	Button,
	IconButton,
} from "@material-tailwind/react";
import React, { memo, useEffect, useRef, useState } from "react";
import Whatsapp from "../assets/whatsapp.webp";
import Facebook from "../assets/facebook.webp";
import Gmail from "../assets/gmail.webp";
import Linkedin from "../assets/link.webp";
import Attach from "../assets/attach.webp";
import { useDispatch, useSelector } from "react-redux";
import { BsChatDots, BsFillMoonFill, BsFillSunFill, BsShop, BsThreeDots } from "react-icons/bs";
import { FaChevronDown, FaKey, FaWrench } from "react-icons/fa";

import { Tb360View } from "react-icons/tb";
import { IoMdPin, IoMdShare } from "react-icons/io";
import {
	IoDownloadOutline,
	IoHeartOutline,
	IoHelpBuoyOutline,
	IoHelpCircleOutline,
	IoStatsChartOutline,
	IoTrashOutline,
} from "react-icons/io5";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { axiosClient } from "../config/axios";
import { clearCacheAction } from "../redux/userRoute/authenticate/authenticate.slicer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { FaRegCircleUser } from "react-icons/fa6";
import ChatPdf from "./ChatPdf";

const Setting = ({ setIsSettingOpen, logoutHandler }) => {
	const { isUser, isChat: chats } = useSelector((state) => state.authenticate);
	const [selectedTheme, setselectedTheme] = useState("");
	const [isCacheLoading, setIsCacheLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [openPopover, setOpenPopover] = useState(false);
	const [openCache, setOpenCache] = useState(false);
	const [openShare, setOpenShare] = useState(false);

	useEffect(() => {
		setselectedTheme(localStorage.getItem("theme"));
	}, []);

	useEffect(() => {
		if (selectedTheme === "dark") {
			document.documentElement.classList.add("dark");
		} else {
			document.documentElement.classList.remove("dark");
		}
	}, [selectedTheme]);

	const handleOpenTheme = () => {
		if (selectedTheme === "dark") {
			localStorage.removeItem("theme");
			setselectedTheme("");
		} else {
			localStorage.setItem("theme", "dark");
			setselectedTheme("dark");
		}
	};

	const popoverRef = useRef(null);
	const popoverBtnRef = useRef(null);
	const shareRef = useRef(null);
	const shareBtnRef = useRef(null);
	const cacheRef = useRef(null);
	const cacheBtnRef = useRef(null);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [active, setactive] = useState("");

	useEffect(() => {
		if (location) {
			setactive(location.pathname);
		}
	}, [location]); // eslint-disable-line

	useEffect(() => {
		const handleDocumentClick = (event) => {
			if (openPopover) {
				if (popoverRef.current && !popoverRef.current.contains(event.target)) {
					if (popoverBtnRef && !popoverBtnRef.current.contains(event.target))
						if (openCache) {
							if (cacheRef.current && !cacheRef.current.contains(event.target)) {
								setOpenCache(false);
							}
						} else {
							setOpenPopover(false);
							setactive(location.pathname);
						}
				}
			}
			if (openShare) {
				if (shareRef.current && !shareRef.current.contains(event.target)) {
					setactive(location.pathname);
					setOpenShare(false);
				}
			}
		};

		if (openPopover || openShare || openCache) {
			document.addEventListener("mousedown", handleDocumentClick);
			document.body.style.pointerEvents = "none";
		} else {
			document.body.style.pointerEvents = "auto";
		}

		return () => {
			document.removeEventListener("mousedown", handleDocumentClick);
			document.body.style.pointerEvents = "auto";
		};
	}, [openPopover, openShare, openCache]);

	const shareOnSocialMedia = (socialMedia) => {
		let shareURL = "https://viste-guest.vercel.app";

		switch (socialMedia) {
			case "facebook":
				shareURL =
					"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(shareURL);
				break;
			case "google":
				shareURL =
					"https://mail.google.com/mail/u/0/?view=cm&fs=1&to&su=Subject&body=" +
					encodeURIComponent(shareURL);
				break;
			case "linkedin":
				shareURL =
					"https://www.linkedin.com/shareArticle?mini=true&url=" +
					encodeURIComponent(shareURL);
				break;

			case "whatsapp":
				shareURL = "https://api.whatsapp.com/send?text=" + encodeURIComponent(shareURL);
				break;
			default:
				break;
		}

		window.open(shareURL, "_blank");
	};

	const copyToClipboard = () => {
		const text = "https://viste-guest.vercel.app";

		const textarea = document.createElement("textarea");
		textarea.value = text;

		textarea.style.position = "fixed";
		textarea.style.opacity = 0;

		document.body.appendChild(textarea);

		textarea.select();
		document.execCommand("copy");

		document.body.removeChild(textarea);

		alert("Copied to clipboard: " + text);
	};

	const clearCache = async () => {
		try {
			setIsCacheLoading(true);
			const { data } = await axiosClient.delete("/cache/clear");
			setIsCacheLoading(false);
			setIsSettingOpen(false);
			alert("Cache Cleared");
			await dispatch(
				clearCacheAction({
					chats: data.chats,
					set1Message: data.set1Message,
					set2Message: data.set2Message,
					set1MessageList: data.set1MessageList,
					set2MessageList: data.set2MessageList,
				})
			);
			navigate("/");
		} catch (err) {
			console.log(err);
			setIsCacheLoading(false);
		}
	};

	return (
		<div className="h-screen flex flex-col bg-gray-50 dark:bg-[#111]">
			<div
				onClick={() => setIsSettingOpen(false)}
				className="flex items-center justify-between pr-4"
			>
				<h2 className="text-center w-1/3 text-gray-100 text-xl pl-4 py-2 md:py-[22px]"></h2>
				<svg
					width="24"
					style={{ color: "white", fill: "white" }}
					height="24"
					viewBox="0 0 24 24"
					fill="white"
					xmlns="http://www.w3.org/2000/svg"
					className="icon-md"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M3 8C3 7.44772 3.44772 7 4 7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H4C3.44772 9 3 8.55228 3 8ZM3 16C3 15.4477 3.44772 15 4 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H4C3.44772 17 3 16.5523 3 16Z"
						fill="currentColor"
					></path>
				</svg>
			</div>
			<div className="flex flex-col mt-3 px-4 dark:text-gray-300 text-gray-900">
				<div className="space-y-1">
					{[
						{
							to: "/checkin",
							text: isUser.lang === "en" ? "Check in / Access" : "Check in / Acceso",
							icon: (
								<FaKey
									style={{
										fontSize: "18px",
										color: active === "/checkin" ? "#EC5633" : "inherit",
									}}
								/>
							),
							restricted: true,
						},
						{
							to: "/",
							text: isUser.lang === "en" ? "Chat" : "IAnfitrión",
							icon: (
								<BsChatDots
									style={{
										fontSize: "18px",
										color: active === "/" ? "#EC5633" : "inherit",
									}}
								/>
							),
						},
						{
							to: "/viste",
							text: "VISTE",
							icon: (
								<Tb360View
									style={{
										fontSize: "18px",
										color: active === "/viste" ? "#EC5633" : "inherit",
									}}
								/>
							),
						},

						{
							to: "/guestshop",
							text: "GuestShop",
							// isUser.lang === "en"
							// 	? "GuestShop"
							// 	: "GuestShop",
							icon: (
								// <img className=" w-[18px] h-5" src={Alfredin} />

								<BsShop
									style={{
										fontSize: "18px",
										color: active === "/guestshop" ? "#EC5633" : "inherit",
									}}
								/>
							),
						},
					].map((link) => (
						<NavLink
							key={link.to}
							onClick={() => {
								setactive(link.to);
								setIsSettingOpen(false);
							}}
							to={link.to}
							style={{
								pointerEvents:
									openPopover || openShare || openCache ? "none" : "auto",
							}}
							className={`flex items-center w-full px-3  rounded-md h-10 bg-inherit
							cursor-pointer dark:hover:bg-[#ffffff17] hover:bg-gray-200 active:bg-[#cfd2dab6] dark:active:bg-[#ffffff3e]`}
						>
							{link.icon}
							<span
								className={`text-sm ml-2 ${
									active === link.to ? "text-[#EC5633]" : "text-inherit"
								}`}
							>
								{link.text}
							</span>
							{link.restricted && !isUser.policeFormSubmitted && (
								<strong className=" w-2 h-2 bg-red-900 rounded-full ml-1"></strong>
							)}
						</NavLink>
					))}
				</div>

				<Accordion open={open}>
					<AccordionHeader
						onClick={() => setOpen((prev) => !prev)}
						className={`flex items-center justify-between w-full px-3  rounded-md h-10
						  cursor-pointer hover:bg-[#ffffff17] text-gray-700 dark:text-gray-500 border-none hover:text-gray-800 dark:hover:text-gray-500`}
					>
						<div className="flex items-center justify-start">
							<FaChevronDown
								className={`mx-auto h-4 w-4 font-extralight transition-transform ${
									open ? "rotate-180" : ""
								}`}
							/>

							<span className="text-sm font-thin ml-2">
								{open ? (
									<>{isUser.lang === "en" ? "Less" : "Menos"}</>
								) : (
									<>{isUser.lang === "en" ? "More" : "Mas"}</>
								)}
							</span>
						</div>
					</AccordionHeader>
					<AccordionBody className="text-gray-900 dark:text-gray-300 py-0">
						<NavLink
							onClick={() => {
								setactive("/pathfinder");
								setIsSettingOpen(false);
							}}
							to="/pathfinder"
							style={{
								pointerEvents:
									openPopover || openShare || openCache ? "none" : "auto",
							}}
							className={`flex items-center w-full px-3  rounded-md h-10 bg-inherit
						 cursor-pointer hover:bg-[#ffffff17] active:bg-[#ffffff3e]`}
						>
							<IoMdPin
								style={{
									fontSize: "18px",
									color: active === "/pathfinder" ? "#EC5633" : "inherit",
								}}
							/>
							<span
								className={`text-sm ml-2 ${
									active === "/pathfinder" ? "text-[#EC5633]" : "text-inherit"
								}`}
							>
								{isUser.lang === "en" ? "Pathfinder" : "Camino"}
							</span>
						</NavLink>
						<NavLink
							onClick={() => {
								setactive("/reportissue");
								setIsSettingOpen(false);
							}}
							to="/reportissue"
							style={{
								pointerEvents:
									openPopover || openShare || openCache ? "none" : "auto",
							}}
							className={`flex items-center w-full px-3  rounded-md h-10 bg-inherit cursor-pointer dark:hover:bg-[#ffffff17] hover:bg-gray-200 active:bg-[#cfd2dab6] dark:active:bg-[#ffffff3e]`}
						>
							<FaWrench
								style={{
									fontSize: "18px",
									color: active === "/reportissue" ? "#EC5633" : "inherit",
								}}
							/>
							<span
								className={`text-sm ml-2 ${
									active === "/reportissue" ? "text-[#EC5633]" : "text-inherit"
								}`}
							>
								{isUser.lang === "en" ? "Report Issue" : "Reportar Incidencia"}
							</span>
						</NavLink>
						<NavLink
							onClick={() => {
								setactive("/helpdesk");
								setIsSettingOpen(false);
							}}
							to="/helpdesk"
							style={{
								pointerEvents:
									openPopover || openShare || openCache ? "none" : "auto",
							}}
							className={`flex items-center w-full px-3  rounded-md h-10 bg-inherit cursor-pointer dark:hover:bg-[#ffffff17] hover:bg-gray-200 active:bg-[#cfd2dab6] dark:active:bg-[#ffffff3e]`}
						>
							<IoHelpBuoyOutline
								style={{
									fontSize: "18px",
									color: active === "/helpdesk" ? "#EC5633" : "inherit",
								}}
							/>
							<span
								className={`text-sm ml-2 ${
									active === "/helpdesk" ? "text-[#EC5633]" : "text-inherit"
								}`}
							>
								{isUser.lang === "en" ? "Helpdesk" : "Asistencia"}
							</span>
						</NavLink>
						<NavLink
							to="/loved"
							onClick={() => {
								setactive("/loved");
								setIsSettingOpen(false);
							}}
							style={{
								pointerEvents:
									openPopover || openShare || openCache ? "none" : "auto",
							}}
							className={`flex items-center w-full px-3 rounded-md h-10 cursor-pointer bg-inherit dark:hover:bg-[#ffffff17] hover:bg-gray-200 active:bg-[#cfd2dab6] dark:active:bg-[#ffffff3e]`}
						>
							<IoHeartOutline
								style={{
									fontSize: "18px",
									color: active === "/loved" ? "#EC5633" : "inherit",
								}}
							/>
							<span
								className={`text-sm ml-2 ${
									active === "/loved" ? "text-[#EC5633]" : "text-inherit"
								}`}
							>
								{isUser.lang === "en" ? "Loved" : "Favoritas"}
							</span>
						</NavLink>
						<div
							ref={shareBtnRef}
							style={{
								pointerEvents:
									openPopover || openShare || openCache ? "none" : "auto",
							}}
							className={`flex items-center w-full px-3 sm:py-3 rounded-md h-10 cursor-pointer bg-inherit
							dark:hover:bg-[#ffffff17] hover:bg-gray-200 active:bg-[#cfd2dab6] dark:active:bg-[#ffffff3e] `}
							onClick={() => {
								setOpenPopover(false);
								setOpenCache(false);
								setOpenShare(true);
								setactive("/share");
							}}
						>
							<IoMdShare
								style={{
									fontSize: "18px",
									color: active === "/share" ? "#EC5633" : "inherit",
								}}
							/>
							<span
								className={`text-sm ml-2 ${
									active === "/share" ? "text-[#EC5633]" : "text-inherit"
								}`}
							>
								{isUser.lang === "en" ? "Share" : "Compartir"}
							</span>
						</div>
					</AccordionBody>
				</Accordion>
			</div>

			<div className="mt-auto sticky bottom-[2%] ">
				{openShare && (
					<div
						ref={shareRef}
						style={{
							pointerEvents: openPopover || openCache ? "none" : "auto",
						}}
						className={`flex items-center justify-center gap-4 text-white bg-gray-300 dark:bg-[#333] rounded-lg  my-2 absolute bottom-16 w-11/12 mx-3 px-3 py-7`}
					>
						<button onClick={() => shareOnSocialMedia("google")}>
							<img className="w-[32px] " src={Gmail} alt="gmail" />
						</button>
						<button onClick={() => shareOnSocialMedia("facebook")}>
							<img className="w-[32px] " src={Facebook} alt="facebook" />
						</button>
						<button onClick={() => shareOnSocialMedia("whatsapp")}>
							<img className="w-[32px] " src={Whatsapp} alt="whatsapp" />
						</button>
						<button onClick={() => shareOnSocialMedia("linkedin")}>
							<img className="w-[32px] " src={Linkedin} alt="linkedin" />
						</button>
						<button onClick={() => copyToClipboard()}>
							<img className="w-[32px] " src={Attach} alt="attachment" />
						</button>
					</div>
				)}
				{openCache && (
					<div
						ref={cacheRef}
						style={{
							pointerEvents: openShare ? "none" : "auto",
						}}
						className={`text-gray-50 py-5 px-3 rounded-md bg-[#545454] my-2 transition-all absolute bottom-16 w-11/12 mx-3 z-[100000]`}
					>
						<p className="text-center text-sm">
							Clearing will erase our chat history <br />
							Are you sure?
						</p>
						<div className="flex justify-between mt-5 mx-2">
							<Button
								onClick={clearCache}
								disabled={isCacheLoading}
								className="bg-gray-600 disabled:cursor-not-allowed"
							>
								Yes
							</Button>
							<Button
								disabled={isCacheLoading}
								onClick={() => setOpenCache(false)}
								className="bg-gray-600 disabled:cursor-not-allowed"
							>
								No
							</Button>
						</div>
					</div>
				)}
				{openPopover && (
					<div
						style={{
							pointerEvents: openShare || openCache ? "none" : "auto",
						}}
						ref={popoverRef}
						className={`flex flex-col items-center justify-center text-gray-900 dark:text-white mx-2 px-3 rounded-md bg-gray-200 dark:bg-[#10253d] h-fit mb-2 py-2 popover-enter`}
					>
						{[
							{
								to: "/faq",
								text: isUser.lang === "en" ? "Faq's" : "Preguntas Frecuentes",
								icon: (
									<IoHelpCircleOutline
										style={{
											fontSize: "18px",
											color: active === "/faq" ? "#EC5633" : "inherit",
										}}
									/>
								),
							},
							{
								to: "/feedback",
								text: isUser.lang === "en" ? "Feedback" : "Opinion",
								icon: (
									<IoStatsChartOutline
										style={{
											fontSize: "18px",
											color: active === "/feedback" ? "#EC5633" : "inherit",
										}}
									/>
								),
							},
						].map((link) => (
							<NavLink
								style={{
									pointerEvents: openCache ? "none" : "auto",
								}}
								key={link.to}
								to={link.to}
								onClick={() => {
									setactive(link.to);
									setIsSettingOpen(false);
									setOpenPopover(false);
								}}
								className={`flex items-center w-full px-3 py-1 sm:py-1 rounded-md h-10 sm:h-12 cursor-pointer bg-inherit dark:hover:bg-[#ffffff17] hover:bg-gray-300 active:bg-[#a4a9b7d4] dark:active:bg-[#ffffff3e]`}
							>
								{link.icon}
								<span
									className={`text-sm ml-2 ${
										active === link.to ? "text-[#EC5633]" : "text-inherit"
									}`}
								>
									{link.text}
								</span>
							</NavLink>
						))}
						<div
							onClick={() => {
								handleOpenTheme();
							}}
							className={`flex items-center w-full px-3 py-1 sm:py-1 rounded-md h-10 sm:h-12 cursor-pointer bg-inherit dark:hover:bg-[#ffffff17] hover:bg-gray-300 active:bg-[#a4a9b7d4] dark:active:bg-[#ffffff3e]`}
						>
							{selectedTheme === "dark" ? (
								<BsFillMoonFill
									className={`${
										active === "/theme"
											? "text-[#EC5633]"
											: "dark:text-white text-gray-800"
									}`}
								/>
							) : (
								<BsFillSunFill
									className={`${
										active === "/theme"
											? "text-[#EC5633]"
											: "dark:text-white text-gray-800"
									}`}
								/>
							)}

							<span className="text-sm ml-2">
								{" "}
								{isUser.lang === "en" ? "Theme" : "Tema"}
							</span>
						</div>
						<PDFDownloadLink
							className={`flex items-center w-full px-3 py-1 sm:py-1 rounded-md h-10 sm:h-12 cursor-pointer bg-inherit dark:hover:bg-[#ffffff17] hover:bg-gray-300 active:bg-[#a4a9b7d4] dark:active:bg-[#ffffff3e]`}
							document={<ChatPdf chats={chats} />}
							fileName="chat.pdf"
						>
							<IoDownloadOutline
								style={{
									fontSize: "18px",
									color: active === "/pdf" ? "#EC5633" : "inherit",
								}}
							/>
							<span className="text-sm ml-2">
								{isUser.lang === "en" ? "Download Chat" : "Descargar Chat"}
							</span>
						</PDFDownloadLink>

						<div
							ref={cacheBtnRef}
							onClick={() => {
								setOpenShare(false);
								setOpenCache(!openCache);
							}}
							className={`flex items-center w-full px-3 py-1 sm:py-1 rounded-md h-10 sm:h-12 cursor-pointer bg-inherit dark:hover:bg-[#ffffff17] hover:bg-gray-300 active:bg-[#a4a9b7d4] dark:active:bg-[#ffffff3e]`}
						>
							<IoTrashOutline
								style={{
									fontSize: "18px",
									color: active === "/cache" ? "#EC5633" : "inherit",
								}}
							/>
							<span className="text-sm ml-2">
								{isUser.lang === "en" ? "Clear Cache" : "Limpiar Caché"}
							</span>
						</div>
						<div
							className="flex items-center w-full px-3 py-2 sm:py-3 rounded-md h-10 sm:h-12 cursor-pointer bg-inherit dark:hover:bg-[#ffffff17] hover:bg-gray-300 active:bg-[#a4a9b7d4] dark:active:bg-[#ffffff3e]"
							onClick={() => {
								logoutHandler();
							}}
						>
							<FaRegCircleUser style={{ fontSize: "18px" }} />
							<span className="text-sm ml-2">
								{isUser.lang === "en" ? "Log out" : "Cerrar Sesión"}
							</span>
						</div>
					</div>
				)}

				<div className="flex mb-1 mx-4 px-3 justify-between items-center rounded-md h-12 sm:h-14 bg-gray-50  dark:bg-[#333]  shadow-md ">
					<div className="flex items-center gap-3 text-black dark:text-white text-sm">
						{isUser?.image ? (
							<img
								src={isUser.image}
								alt={isUser.name}
								style={{
									borderRadius: "999px",
									width: "24px",
									height: "24px",
									objectFit: "cover",
								}}
							/>
						) : (
							<FaRegCircleUser style={{ fontSize: "20px" }} />
						)}
						<span>{isUser?.name}</span>
					</div>

					<IconButton
						ref={popoverBtnRef}
						variant="text"
						onClick={(e) => {
							e.stopPropagation();
							setOpenCache(false);
							setOpenShare(false);
							if (openPopover) {
								setOpenPopover(false);
							} else {
								setOpenPopover(true);
							}
						}}
					>
						<BsThreeDots
							className="cursor-pointer w-12 dark:text-white text-gray-800"
							style={{
								fontSize: "18px",
							}}
						/>
					</IconButton>
				</div>
			</div>
		</div>
	);
};

export default memo(Setting);
